<template>
  <ValidationProvider :name="$attrs.label" :rules="rules" v-slot="{ errors, valid }">
    <v-combobox
        chips
        v-bind="$attrs"
        v-model="innerValue"
        v-on="$listeners"
        :error-messages="errors.concat($attrs.errors || [])"
        :items="items"
        :label="$t(`label.${$attrs.label}`)"
        :success="innerValue > 0 && valid"
        :return-object="false"

        item-value="text"
    >

      <template v-slot:selection="data">
        <v-chip
            v-bind="data.attrs"
            :disabled="data.disabled"
            :input-value="data.selected"
            :key="JSON.stringify(data.item)"
            :set="dataObj = getItemByText(data.item) || data.item"
            @click:close="data.parent.selectItem(data.item)"
        >
          <v-avatar left color="primary">
            <v-img v-if="dataObj.image" :src="dataObj.image"/>
            <span v-else-if="dataObj.text" v-text="dataObj.text.slice(0, 1).toUpperCase()" class="white--text"/>
            <span v-else v-text="dataObj.toString().slice(0, 2).toUpperCase()" class="white--text"/>
          </v-avatar>
          {{ dataObj.text || dataObj }}
        </v-chip>
      </template>
      <template v-slot:item="data">
        <v-list-item-avatar v-if="isObject(data.item) && 'image' in data.item" color="primary">
          <v-img v-if="data.item.image" :src="data.item.image"/>
          <span v-else v-text="data.item.text.slice(0, 1).toUpperCase()" class="white--text"/>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.text"></v-list-item-title>
        </v-list-item-content>
      </template>
    </v-combobox>
  </ValidationProvider>
</template>

<script>
import {ValidationProvider} from "vee-validate";
import isObject from 'lodash/isObject';

export default {
  components: {
    ValidationProvider
  },
  props: {
    rules: {
      type: [Object, String],
      default: ""
    },
    items: {
      type: [Object, Array],
      default: []
    },
    // must be included in props
    value: {
      type: null
    },
    model: {
      type: null
    },
  },
  data: () => ({
    innerValue: "",
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      let item = this.getItemByText(newVal);
      this.$emit("input", newVal);
      this.$emit("model", item ? item.value : null);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  methods: {
    getItemByValue(value) {
      return this.items.find(x => x.value === value)
    },
    getItemByText(text) {
      return this.items.find(x => x.text === text)
    },
    isObject: isObject
  }
};
</script>
